import { render } from "./ViewSharedRecording.vue?vue&type=template&id=247835d7&scoped=true"
import script from "./ViewSharedRecording.vue?vue&type=script&lang=js"
export * from "./ViewSharedRecording.vue?vue&type=script&lang=js"

import "./ViewSharedRecording.vue?vue&type=style&index=0&id=247835d7&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247835d7"]])

export default __exports__